<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="mx-1">
    <NewEditTrigger :method="method"
                     :selectedTriggerId="selectedTriggerId"
                     v-model="isNewEditTriggerDialogVisible"
                     @getTriggers="getTriggers()" />
    <view-trigger :selected-trigger-id="selectedTriggerId"
                  v-model="isViewTriggerDialogVisible"
                    @changeTriggerStatus="getTriggers()"
                  />

    <v-col cols="12" class="d-flex justify-end pt-0">
        <v-btn color="kbPurple"
               dark
               @click="openNewTriggerDialog()">
            {{ $t('general.addNew') }}
        </v-btn>
    </v-col>
    <v-col cols="12" class="text-h6 pb-0">
        <v-data-table :headers="headers"
                      :height="dataTableHeight"
                      fixed-header
                      :items="triggers"
                      class="elevation-2"
                      :loading="loadingTriggers"
                      :options.sync="options"
                      :footer-props="{
                        'items-per-page-text': `${$t('general.triggers')} ${$t('general.perPage')}`,
                        'items-per-page-options': [15, 50, 200]
                      }"
                      :server-items-length="totalTriggers"
                      :must-sort="false">
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-avatar v-on="on" style="cursor: pointer;" :color="item.isActive ? 'success' : 'error'" size="10"></v-avatar>
                  </template>
                  <span>
                      {{ item.isActive ? $t('general.active') : $t('general.inactive') }}
                  </span>
                </v-tooltip>
              </td>
              <td class="font-weight-bold">{{ item.title || $t('general.noTitle') }}</td>
              <td>{{ convertTZToUserTZ(item.createdAt) | moment('DD/MM/YYYY hh:mma') }}</td>
              <td class="ma-0 pa-0">
                <div class="data-table-actions d-flex justify-center align-center">
                  <v-btn icon color="primary" text @click="openViewTriggerDialog(item._id)">
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                  <v-btn icon text @click="openUpdateTriggerDialog(item._id)" color="primary">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-switch style="position: relative; top: 25%; max-width: fit-content;"
                            color="info"
                            :input-value="item.isActive"
                            hide-details
                            @change="changeTriggerStatus($event, item)"/>
                </div>
              </td>
            </tr>
          </template>

          <template v-slot:no-data>
            <v-row>
              <v-col class="text-center" cols="12" v-if="loadingTriggers">
                {{ $t('general.loadingTriggers') }}
              </v-col>
              <v-col cols="12" class="red--text text-center" v-else>
                {{ $t('general.noRegisteredTriggers') }}
              </v-col>
            </v-row>
          </template>
        </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import NewEditTrigger from '@/pages/App/Triggers/dialogs/NewEditTrigger.vue'
import ViewTrigger from '@/pages/App/Triggers/dialogs/ViewTrigger.vue'
import ModuleTableHeight from '@/mixins/ModuleTableHeight'
import TimeZones from '@/mixins/TimeZones'
export default {
  components: { ViewTrigger, NewEditTrigger },
  created () {
    this.$store.dispatch('getTriggerToDoList')
    this.$store.dispatch('getTriggerActionTypesList')
  },
  computed: {
    ...mapState({
      triggers: state => state.triggers.triggers,
      totalTriggers: state => state.triggers.totalTriggers
    }),
    headers () {
      return [
        { text: '', value: 'isActive', sortable: false },
        { text: this.$t('general.title'), value: 'title' },
        { text: this.$t('general.creationDate'), value: 'createdAt' },
        { text: this.$t('general.actions'), align: 'center', sortable: false, value: '' }
      ]
    }
  },
  data () {
    return {
      isNewEditTriggerDialogVisible: false,
      isViewTriggerDialogVisible: false,
      loadingTriggers: false,
      method: 'create',
      options: {},
      selectedTriggerId: ''
    }
  },
  methods: {
    async getTriggers () {
      try {
        this.loadingTriggers = true
        this.$store.commit('SET_PAGINATION_TRIGGERS',
          {
            page: this.options.page,
            itemsPerPage: this.options.itemsPerPage,
            sortBy: this.options.sortBy[0],
            descending: this.options.sortDesc[0]
          }
        )
        await this.$store.dispatch('getTriggers')
        this.loadingTriggers = false
      } catch (e) {
        this.loadingTriggers = false
        notifications.error(e)
      }
    },
    openNewTriggerDialog () {
      this.method = 'create'
      this.selectedTrigger = ''
      this.isNewEditTriggerDialogVisible = true
    },
    openUpdateTriggerDialog (triggerId) {
      this.method = 'edit'
      this.selectedTriggerId = triggerId
      this.isNewEditTriggerDialogVisible = true
    },
    openViewTriggerDialog (triggerId) {
      this.selectedTriggerId = triggerId
      this.isViewTriggerDialogVisible = true
    },
    async changeTriggerStatus (status, trigger) {
      trigger.isActive = status
      try {
        await this.$store.dispatch('updateTrigger', trigger)
      } catch (e) {
        notifications.error(e)
      }
    }
  },
  mixins: [ModuleTableHeight, TimeZones],
  watch: {
    options: {
      handler () {
        this.getTriggers()
        this.$vuetify.goTo(0)
      },
      deep: true
    }
  }
}
</script>
